import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';
import { OrganizationSchema, LocalBusinessSchema } from '../components/StructuredData';
import MagicTimelineSection from '../components/MagicTimelineSection';
import TimelineSection from '../components/TimelineSection';
import WhoWeAre from '../components/WhoWeAre';
import PartnersSection from '../components/PartnersSection';
import ServicesGrid from '../components/ServicesGrid';
import FeaturedInstagram from '../components/FeaturedInstagram';
import RecentArticles from '../components/RecentArticles';

const HomePage = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  const sampleMilestones = [
  {
    title: "Discovery",
    subtitle: "Phase 1",
    description: "Uncover the magic within your communication strategy and identify key opportunities for transformation."
  },
  {
    title: "Strategy",
    subtitle: "Phase 2", 
    description: "Develop a comprehensive roadmap that aligns your messaging with your brand's unique voice and vision."
  },
  {
    title: "Implementation",
    subtitle: "Phase 3",
    description: "Execute your communication plan with precision, leveraging cutting-edge tools and techniques."
  },
  {
    title: "Growth",
    subtitle: "Phase 4",
    description: "Scale your success and watch your brand's influence expand across all communication channels."
  }
];

return (
    <>
      <SEO 
        title="Communications Agency"
        description="Magicomms is a PR & Communications Agency specializing in media relations, press office, corporate and sports communications."
        keywords="communications agency, PR agency, press office, sports communications, media relations, crisis management, corporate communications, digital content, reputation management"
        lang="it"
      />
      <OrganizationSchema />
      <LocalBusinessSchema />

      {/* Section 1: Magic Animation */}
      <section className="animation-section">
        <MagicTimelineSection 
          variant="light" 
          milestones={sampleMilestones}
        />
      </section>

      {/* Section 2: Timeline */}
      <TimelineSection />

      {/* Section 3: Who We Are */}
      <WhoWeAre />

      {/* Section 4: Featured Instagram */}
      <FeaturedInstagram />

      {/* Section 5: Services */}
      <ServicesGrid />

      {/* Section 6: Partners */}
      <PartnersSection />

      {/* Section 7: Recent Articles */}
      <RecentArticles />
    </>
  );
};

export default HomePage;
